import styled, { css } from "styled-components";
import { parseSizeToken, useDesignTokens } from "@boi/react-design-tokens";
import { CoreTypography } from "@boi/components-core";

type TypographyBaseProps = {
  $variant: CoreTypography.Variant;
  $fontFamily?: CoreTypography.FontFamily;
  $noWrap?: boolean;
  $color?: string;
};

export const TypographyBase = styled.p<TypographyBaseProps>`
  ${({ $variant, $fontFamily, $noWrap, $color }) => {
    const { tokens } = useDesignTokens();
    const { typography, fontFamily } = tokens;

    const fontSize = parseSizeToken(typography.fontSize[$variant]);
    const lineHeight = parseSizeToken(typography.lineHeight[$variant]);

    return [
      css`
        margin: 0;
        font-weight: normal;
        color: ${$color ? $color : typography.color[$variant]};
        font-size: ${fontSize};
        line-height: ${lineHeight};
        font-family: ${typography.fontFamily[$variant]};
      `,
      $fontFamily &&
        css`
          font-family: ${fontFamily[$fontFamily]};
        `,
      $noWrap &&
        css`
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        `,
      CoreTypography.STANDARD_VARIANTS.includes($variant as any) &&
        css`
          & strong,
          & b {
            font-family: ${fontFamily.OpenSansBold};

            & em,
            & i {
              font-family: ${fontFamily.OpenSansSemiBoldItalic};
            }
          }

          & em,
          & i {
            font-family: ${CoreTypography.BOLD_FONT_FAMILIES.includes(
              $fontFamily as any
            )
              ? fontFamily.OpenSansSemiBoldItalic
              : fontFamily.OpenSansItalic};

            & strong,
            & b {
              font-family: ${fontFamily.OpenSansSemiBoldItalic};
            }
          }
        `,
    ];
  }}
`;
